// app/components/native-tapioca-starch-manufacturing-process/Hero.tsx
"use client";

import * as React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { Box, Grid } from "@mui/material";
import { useTranslations } from "next-intl";

export default function Hero() {
  const t = useTranslations("ManufacturingProcess");

  return (
    <Box className="policy-hero">
      <Container className="container">
        <Grid container>
          <Grid size={12}>
            <Typography
              variant="h1"
              data-aos="zoom-in"
              sx={{ mb: 1, whiteSpace: { xs: "normal", lg: "pre-line" } }}
            >
              {t("Hero.title")}
            </Typography>
            <Typography variant="body1" data-aos="zoom-in">
              {t("Hero.subtitle")}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
